import { Container } from '@/components/layout/Container';
import { COLORS } from '@/styles/color';
import { mediaBreakpointUp, paddingY } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import styled from 'styled-components';

const Wrapper = styled.div<{ backgroundColor?: string }>`
  background-color: ${(props) => props.backgroundColor ?? 'transparent'};
  color: ${(props) => (props.backgroundColor ? COLORS.WHITE : COLORS.BLACK)};

  ${(props) => paddingY(props.backgroundColor ? 50 : 0)}

  ${mediaBreakpointUp('desktop')} {
    ${(props) => paddingY(props.backgroundColor ? 80 : 0)}
  }

  ${mediaBreakpointUp('desktopWide')} {
    ${(props) => paddingY(props.backgroundColor ? 120 : 0)}
  }
`;

const Grid = styled(Container)`
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: repeat(2, auto);
  gap: 20px;

  ${mediaBreakpointUp('tablet')} {
    grid-template-columns: repeat(9, 1fr);
    grid-template-rows: auto;
    align-items: center;
  }

  ${mediaBreakpointUp('desktop')} {
    grid-template-columns: repeat(18, 1fr);
  }
`;

const AssetWrapper = styled.div`
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  width: 100%;

  video {
    object-fit: cover;
    object-position: center;
  }

  ${mediaBreakpointUp('tablet')} {
    grid-row: 1;
    grid-column-start: 1;
    grid-column-end: span 4;

    ${Wrapper}[data-grid-reversed="true"] & {
      grid-column-start: 6;
    }
  }

  ${mediaBreakpointUp('desktop')} {
    grid-column-end: span 9;

    ${Wrapper}[data-grid-reversed="true"] & {
      grid-column-start: 10;
    }
  }

  ${mediaBreakpointUp('desktopWide')} {
    grid-column-start: 2;
    grid-column-end: span 8;
  }
`;

const ContentWrapper = styled.div`
  ${customTextSize(14, 20)};

  a {
    text-decoration: underline;
    font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  }

  ${mediaBreakpointUp('tablet')} {
    grid-row: 1;
    grid-column-start: 5;
    grid-column-end: span 5;

    ${Wrapper}[data-grid-reversed="true"] & {
      grid-column-start: 1;
    }
  }

  ${mediaBreakpointUp('desktop')} {
    grid-column-start: 11;
    grid-column-end: span 8;
    ${customTextSize(18, 26)}
  }

  ${mediaBreakpointUp('desktopWide')} {
    grid-column-start: 11;
    grid-column-end: span 7;

    ${Wrapper}[data-grid-reversed="true"] & {
      grid-column-start: 2;
    }
  }
`;

const Heading = styled.h4<{ textColor?: string }>`
  ${customTextSize(16, 21)}
  font-weight: ${FONT_WEIGHTS.BOLD};
  margin-bottom: 20px;
  color: ${(props) => props.textColor ?? COLORS.BLACK};

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(27, 35)}
    font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  }
`;

const TagContainer = styled.div`
  margin-top: 20px;
  padding: 12px 0;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px 10px;
`;

const CTA = styled.a`
  display: inline-flex;
  align-items: center;
  ${customTextSize(16, 20)};
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  margin-top: ${remCalc(20)};

  svg {
    transform: rotate(180deg);
    margin-left: 0.25rem;
  }
`;

const featureBlockComponents = {
  Wrapper,
  Grid,
  AssetWrapper,
  ContentWrapper,
  Heading,
  TagContainer,
  CTA,
};

export default featureBlockComponents;
